// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__LjbK+","Logo":"Header_Logo__QPonA","Menu":"Header_Menu__VlyUu"};